import { validateCoupon } from "./coupons";

export const FIXED_PRESETS = [1, 2, 3, 5];
export const PERCENT_PRESETS = [10, 15, 20, 30];

export const maxDiscountable = (subtotal) => Math.max(0, Number(subtotal) || 0);

export const computeReductionAmount = (reduction, subtotal) => {
  if (!reduction || reduction.type === "none") return 0;
  const base = maxDiscountable(subtotal);
  if (base <= 0) return 0;

  if (reduction.type === "coupon") {
    return Math.min(Number(reduction.discount) || 0, base);
  }
  if (reduction.type === "fixed") {
    const v = Math.min(Number(reduction.value) || 0, base);
    return Math.max(0, v);
  }
  if (reduction.type === "percent") {
    const pct = Math.min(Math.max(Number(reduction.value) || 0, 0), 100);
    return +(base * pct / 100).toFixed(2);
  }
  return 0;
};

export const finalTotal = (subtotal, reduction) => {
  const amount = computeReductionAmount(reduction, subtotal);
  return +(Number(subtotal) || 0 - amount).toFixed(2);
};

export const reductionKey = (reduction) => {
  if (!reduction || reduction.type === "none") return "";
  if (reduction.type === "coupon") return `coupon-${reduction.couponCode || ""}`;
  if (reduction.type === "fixed") return `fixed-${reduction.value}`;
  if (reduction.type === "percent") return `pct-${reduction.value}`;
  return "";
};

export const reductionDisplayLabel = (reduction) => {
  if (!reduction || reduction.type === "none") return "";
  if (reduction.type === "coupon") return `Code ${reduction.couponCode}`;
  if (reduction.type === "fixed") return `${Number(reduction.value).toFixed(2)} €`;
  if (reduction.type === "percent") return `${reduction.value} %`;
  return "";
};

export const validateReductionCode = (code, subtotal, catalog) => {
  return validateCoupon(code, subtotal, catalog);
};
